import * as React from 'react';
import Node from './Node';

class TreeView extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {};

        this.onToggle = this.onToggle.bind(this);
        this.moveNode = this.moveNode.bind(this);
    }

    onToggle(item: any) {
        this.props.onToggle(item.id);
    }

    moveNode(item: any, targetItem: any, isOver: boolean = false, setAsChild: boolean = false) {
        if (item.id === targetItem.id) {
            return;
        }

        this.props.onMove(targetItem, item);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return JSON.stringify(this.props.data) !== JSON.stringify(nextProps.data);
    }

    render() {
        return (
            <ul className="broker-list">
                {this.props.data.map(
                    (node: any, index: any) =>
                        node.show && (
                            <Node
                                key={node.id || index}
                                item={node}
                                move={this.moveNode}
                                onToggle={this.onToggle}
                                onClick={this.props.onClick}
                                onAdd={this.props.onAdd}
                                canCreate={this.props.canCreate}
                                onDelete={this.props.onDelete}
                                canMove={this.props.canMove}
                                canDelete={this.props.canDelete}
                                showLogs={this.props.showLogs}
                                canRestore={this.props.canRestore}
                                onRestore={this.props.onRestore}
                            />
                        )
                )}
            </ul>
        );
    }
}

export default TreeView;
